<script>

export default {
    name: "PaginateButton"
}
</script>

<template>
<div class="paginate-button" @click="$emit('click')">
    <span>
        <slot></slot>
    </span>
</div>
</template>

<style scoped lang="scss">
.paginate-button {
    /* _Button base */
    cursor: pointer;
    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 14px;
    gap: 8px;

    width: 111px;
    height: 36px;

    /* White */
    background: #FFFFFF;
    /* Gray/300 */
    border: 1px solid #D5D7DA;
    /* Shadow/xs */
    box-shadow: 0 1px 2px rgba(10, 13, 18, 0.05);
    border-radius: 8px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

    span {
        /* Text sm/Semibold */
        font-family: Inter,serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height, or 143% */

        /* Gray/700 */
        color: #414651;
    }
}
</style>
